import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';

interface IProps {
  handlerOnNext: () => void;
  handlerClose: () => void;
  show: boolean;
}

const PaymentCreated = ({ handlerOnNext, handlerClose, show }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Ir a pagos"
    handlerButtonA={() => handlerOnNext()}
    textButtonB="Lo haré después"
    handlerButtonB={() => handlerClose()}
  >
    <DialogExtraCaption
      subtitle="Ya se encuentra disponible tu pago.<br/>Recuerda que una vez realizado el pago podrás descargar tu constancia"
      title="¡Listo!"
      title2="Se ha creado el pago"
    />
  </Dialog>
);

export default PaymentCreated;
